import React from "react";
import BeneficiaryIntro from "../components/BeneficiaryIntro/BeneficiaryIntro";
import { Router } from "@reach/router";
import BeneficiarySuccess from "../components/BeneficiarySuccess/BeneficiarySuccess";
import BeneficiaryFormQuery from "../components/BeneficiaryForm/BeneficiaryFormQuery";
// import styled from "@emotion/styled";

// == Types ================================================================

interface IProps {}

// == Constants ============================================================

BeneficiaryRouter.defaultProps = {};

// == Component ============================================================

export default function BeneficiaryRouter(props: IProps) {
  return (
    <Router>
      <BeneficiaryIntro path="intro"></BeneficiaryIntro>
      <BeneficiaryFormQuery path="new"></BeneficiaryFormQuery>
      <BeneficiarySuccess path="success"></BeneficiarySuccess>
    </Router>
  );
}

// == Styles ===============================================================
